import { AccessLevel } from '@hellodarwin/core/lib/features/entities/pages-entities';
import expertPages from './expert-pages';
import standardPages from './index';

const unresolvedPages = {};

export const selectClientPages = (accessLevel?: AccessLevel) =>
  accessLevel === undefined
    ? unresolvedPages
    : accessLevel === 'expert'
      ? expertPages
      : standardPages;
